import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function VipButton({ isVip, useDeepSeek, setUseDeepSeek, colors, roomId }) {
  const navigate = useNavigate();

  // 👑 VIP View: Functional Toggle
  if (isVip) {
    return (
      <button
        onClick={() => setUseDeepSeek(!useDeepSeek)}
        style={{
          background: useDeepSeek ? colors.primary : 'transparent',
          color: useDeepSeek ? '#fff' : colors.text,
          border: `1px solid ${useDeepSeek ? colors.primary : colors.border}`,
          padding: '6px 12px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 'bold',
          transition: 'all 0.2s ease'
        }}
      >
        🤖 Atlas: {useDeepSeek ? 'Pro' : 'Standard'}
      </button>
    );
  }

  // 🔒 Free User View: The "Tempting" Locked Teaser
  return (
    <button
      onClick={() => navigate(`/checkout?roomId=${roomId}`)}
      title="Upgrade to VIP to unlock Atlas Pro features"
      style={{
        background: 'transparent',
        color: '#888',
        border: `1px dashed ${colors.border}`,
        padding: '6px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.2s ease'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.color = colors.primary;
        e.currentTarget.style.borderColor = colors.primary;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.color = '#888';
        e.currentTarget.style.borderColor = colors.border;
      }}
    >
      <span>🔒</span> Atlas Pro
    </button>
  );
}